import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GDPR_SIGN_OPT_IN = createFcmConfig('gdpr_sign_opt_in', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
